<template>
  <div class="content-c">
    <div class="bank-mid">
      <div class="d-flex m-t-5">
        <p>{{ $lang.BankInfo_txt }}</p>
        <p class="info-color m-l-5">{{ $formatNumberWithCommas(balance) }}</p>
        <img
          class="m-l-10"
          @click="toggleRotation"
          :class="{ rotating: isRotating }"
          src="../../assets/img/general/icon_user_refresh.png"
          width="15"
        />
      </div>
      <div class="m-t-10 m-b-5">
        <span>{{ $lang.BankInfo_txt_withdrawable }}</span>
        <span class="info-color m-l-5 m-r-5">{{ $formatNumberWithCommas(balLimit > 0 ? 0 : balWdl) }}</span>
      </div>
      <div v-if="balLimit > 0" class="m-t-10 m-b-5">
        {{ $lang.BankInfo_txt3 }}
        <span class="info-color m-l-5 m-r-5">{{ $formatNumberWithCommas(balLimit) }}</span>
        {{ $lang.BankInfo_txt4 }}
      </div>
    </div>
    <p v-if="withdrawReadError" class="withdraw-read-error">
      {{ withdrawReadError }}
    </p>
    <p class="p-line"></p>
    <div class="bank-add">
      <div class="type-item d-flex-s t-c">
        <span class="t-c" style="width: 100%">{{ $lang.BankInfo_txt5 }}</span>
        <div class="badgeIcon-c">
          <p class="badgeIcon">
            <van-icon
              name="success"
              color="#ffffff"
              class="badgeIcon-i"
              size="10"
            />
          </p>
        </div>
      </div>
    </div>
    <p class="p-line"></p>
    <div class="bank-list">
      <!-- <van-field
        v-model="realName"
        placeholder="Nome Real"
        class="custom-field"
        :style="{ borderColor: focus ? '#076237' : '#cecece' }"
        @focus="focus = true"
        @blur="focus = false"
        style="background: #f5f5f5"
      >
      </van-field> -->
      <div
        v-if="bankCardList.length > 0"
        @click="selectF"
        style="position: relative"
      >
        <div class="bank-list-add d-flex-s m-t-20">
          <div class="d-flex">
            <!-- <div style="background: #ffffff; padding: 5px; border-radius: 5px">
              <i class="icon iconfont icon-pix" style="color: #32bcad"></i>
            </div> -->
            <span class="m-l-10"><b></b>{{ bankName }}({{ bankCard }})</span>
          </div>
          <van-icon name="arrow-down" :class="{ 'arrow-up': showSelect }" />
        </div>

        <div v-if="showSelect && columns.length > 0" class="bank-select">
          <div
            class="bank-select--i"
            v-for="(item, index) in columns"
            :key="index"
            @click="getSelect(index, item)"
            :class="{ 'select-active': index === selectIndex }"
          >
            <div class="d-flex">
              <!-- <div
                style="
                  background: #ffffff;
                  padding: 5px 5px 2px 5px;
                  border-radius: 5px;
                "
              >
                <img src="../../assets/img/home/pix-H.png" width="18" />
              </div> -->
              <span class="m-l-5">{{ item.label }}({{ item.value }})</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else @click="gotoBank" class="bank-list-add d-flex">
        <ui-icon name="bank" :size="24" />
        <span class="m-l-10">{{ $lang.BankInfo_txt6 }}</span>
      </div>

      <van-field
        v-model="amount"
        placeholder="Please enter the withdrawal amount."
        class="custom-field"
        type="number"
        :style="{ borderColor: focus2 ? '#55657E' : '#55657E' }"
        @focus="focus2 = true"
        @blur="focus2 = false"
        style="margin: 25px 0 30px 0"
      >
        <template #left-icon>
          <span>{{ getCurrency }}</span>
        </template>
        <!-- <template #right-icon>
          <span class="primary-color3">{{ $lang.BankInfo_txt7 }}</span>
        </template> -->
      </van-field>
    </div>
    <p class="p-line"></p>
    <div class="m-t-20" style="padding: 0 10px">
      <p class="m-b-10">{{ $lang.BankInfo_txt8 }}</p>
      <van-password-input
        :value="passWord"
        :error-info="errorInfo"
        :focused="showKeyboard"
        @focus="showKeyboard = true"
      />
      <van-number-keyboard
        v-model="passWord"
        :show="showKeyboard"
        :close-button-text="$lang.Confirmar"
        @blur="showKeyboard = false"
      />
      <van-button
        v-if="isClose !== 1"
        size="large"
        class="custom-button m-t-30"
        :disabled="submitting"
        @click="submit"
      >
        {{ submitting ? ($lang.common_txt67 || $lang.Confirmar) : $lang.Confirmar }}
      </van-button>
      <p v-else class="t-c m-t-10 error-color">{{ withdrawUnavailableMessage }}</p>
    </div>
    <div class="font-color l-h-20" style="width: 96%; margin: 20px auto 0">
      <p class="m-b-5 f-t-15">{{ $lang.common_txt318 }}</p>
      <div>
        <p class="m-t-10">
          {{ $lang.common_txt221 }}
        </p>
        <p class="m-t-10">
          {{ $lang.common_txt222 }}
          {{ withdrawAmountMin }} {{ getCurrency }} {{ $lang.common_txt223 }}
        </p>
        <p class="m-t-10">
          {{ $lang.common_txt224 }}
        </p>
        <p class="m-t-10">
          {{ $lang.common_txt225 }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { Withdraw, WithdrawInit } from '@/api/modules/withdraw'
import {
  contentOf,
  failMessage,
  handleNeedLogin,
  isOk,
  isWithdrawAccepted,
  normalizeBankCardList,
  normalizeMoneyAmount,
  toNumber
} from './paymentFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import md5 from 'md5'

function guardedLocalStorage() {
  try {
    return safeLocalStorage()
  } catch (e) {
    return null
  }
}

function normalizeRechargeBankCardList(cards) {
  if (typeof normalizeBankCardList === 'function') return normalizeBankCardList(cards)
  return (Array.isArray(cards) ? cards : []).map((item) => ({
    ...item,
    cardId: item.cardId || item.id || item.bankCardId || item.card_id,
    bankCard: item.bankCard || item.bank_card || item.accountNo || item.account_no || item.cardNumber || item.card_number || item.cardNo || item.card_no || item.cardNoLast4 || item.card_no_last4 || '',
    bankName: item.bankName || item.bank_name || item.bank || ''
  }))
}

function normalizedCloseFlag(value) {
  const token = String(value == null ? '' : value).trim().toLowerCase()
  return value === true || value === 1 || ['true', '1', 'yes', 'on', 'closed'].includes(token) ? 1 : 0
}

function normalizedPrivacyPasswdSetted(value) {
  const token = String(value == null ? '' : value).trim().toLowerCase()
  if (value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(token)) return 'yes'
  if (value === false || value === 0 || ['false', '0', 'no', 'off'].includes(token)) return 'no'
  return ''
}

function isUnsafeWithdrawCopy(value) {
  const token = String(value == null ? '' : value).trim().toLowerCase()
  return !token ||
    token === 'null' ||
    token === 'undefined' ||
    /read[_\s-]?only|technical[_\s-]?(marker|error|exception)|backend[_\s-]?failure|data[_\s-]?unavailable|mock|fallback|stub/.test(token)
}

function safeWithdrawCopy(value, fallback) {
  const text = String(value == null ? '' : value).trim()
  return isUnsafeWithdrawCopy(text) ? fallback : text
}

export default {
  name: 'BankInfoTab1',
  components: {},
  props: {},
  data() {
    return {
      bankName: '',
      bankId: null,
      columns: [],
      passWord: '',
      errorInfo: '',
      showKeyboard: false,
      amount: null,
      focus2: false,
      focus: false,
      realName: '',
      balance: 0,
      balWdl: 0,
      isRotating: false,
      bankCardList: [],
      showSelect: false,
      selectIndex: 0,
      bankCard: '',
      withdrawAmountSingleMax: 0,
      withdrawAmountMin: 0,
      balLimit: 0,
      privacyPasswdSetted: '',
      isClose: 0,
      closeReason: '',
      withdrawReadError: '',
      submitting: false
    }
  },
  created() {},
  mounted() {
    if (!this.ensureLogin()) return
    this.WithdrawInit()
  },
  computed: {
    withdrawUnavailableMessage() {
      return safeWithdrawCopy(this.closeReason, this.$lang.feature_unavailable || 'Withdrawal is temporarily unavailable. Please try again later.')
    }
  },
  watch: {
    passWord(v) {
      if (v.length === 6) {
        this.showKeyboard = false
      }
      // 确保输入值不超过6位
      if (v.length > 6) {
        v = v.slice(0, 6)
      }
      this.passWord = v
    }
  },
  methods: {
    safeToast(payload) {
      if (typeof this.$toast === 'function') {
        this.$toast(payload)
      }
    },
    getToken() {
      return safeGetStorageItem(guardedLocalStorage(), 'token')
    },
    ensureLogin() {
      if (this.getToken()) return true
      if (this.$bus) this.$bus.$emit('openLogin')
      return false
    },
    showRequestError(data) {
      if (handleNeedLogin(this, data)) return
      this.safeToast({
        message: failMessage(data, this.$lang.request_failed || 'Withdrawal request failed. Please try again later.'),
        icon: 'cross'
      })
    },
    showWithdrawInitError(data) {
      const message = failMessage(data, this.$lang.request_failed || 'Failed to load withdrawal data. Please try again later.')
      this.withdrawReadError = message
      if (handleNeedLogin(this, data)) return
      this.safeToast({
        message,
        icon: 'cross'
      })
    },
    availableWithdrawBalance() {
      const withdrawable = toNumber(this.balWdl, 0)
      if (withdrawable > 0) return withdrawable
      return toNumber(this.balance, 0)
    },
    goSetPassword() {
      this.safeToast({
        message: this.$lang.setPassWord_txt || 'Please set withdrawal password',
        icon: 'cross'
      })
      this.$jumpTo('/setPassWord', { from: 'recharge' })
    },
    selectF() {
      this.showSelect = !this.showSelect
    },
    async submit() {
      if (this.submitting) return
      if (!this.ensureLogin()) return
      if (this.isClose === 1) {
        this.safeToast({
          message: this.withdrawUnavailableMessage,
          icon: 'cross'
        })
        return
      }
      if (this.privacyPasswdSetted === 'no') {
        this.goSetPassword()
        return
      }
      // if (!this.realName) {
      //   this.$toast({
      //     message: 'Por favor, digite seu nome verdadeiro.',
      //     icon: 'info'
      //   })
      // }
      const minAmount = toNumber(this.withdrawAmountMin, 0)
      const maxAmount = toNumber(this.withdrawAmountSingleMax, 0)
      const amountCheck = normalizeMoneyAmount(this.amount, {
        minAmount: minAmount > 0 ? minAmount : 0.01,
        maxAmount: maxAmount > 0 ? maxAmount : 0
      })
      const amount = amountCheck.amount
      const selectedCard = this.bankCardList[this.selectIndex]

      if (!selectedCard || !(selectedCard.cardId || selectedCard.id)) {
        this.safeToast({
          message: this.$lang.BankInfo_txt6 || 'Please add a bank card',
          icon: 'cross'
        })
        return
      }

      if (!amountCheck.ok) {
        this.safeToast({
          message: this.$lang.BankInfo_txt9,
          icon: 'info'
        })
        return
      }
      if (this.passWord.length < 6) {
        this.errorInfo = '6 números'
        return
      } else {
        this.errorInfo = ''
      }
      if (this.balLimit > 0) {
        this.safeToast({
          message: `${this.$lang.BankInfo_txt3} ${this.$formatNumberWithCommas(this.balLimit)} ${this.getCurrency} ${this.$lang.BankInfo_txt4}`,
          icon: 'cross'
        })
        return
      }

      if (this.availableWithdrawBalance() < amount) {
        this.safeToast({
          message: this.$lang.BankInfo_txt10,
          icon: 'cross'
        })
        return
      }

      this.submitting = true
      try {
        const data = await Withdraw({
          privacyPwd: md5(this.passWord),
          // 不再上送 rechargeFees / afterWithdrawAmount：后端 positiveAmount 优先取 withdrawAmount、
          // 手续费由服务端按通道配置重算，二者被忽略；移除以消除“前端定到账额/费率”的资损 footgun。
          withdrawAmount: amount,
          cardId: selectedCard.cardId || selectedCard.id
        })
        if (isWithdrawAccepted(data)) {
          this.safeToast({
            message: this.$lang.Sucesso,
            icon: 'success'
          })
          this.amount = null
          this.passWord = ''
          this.WithdrawInit()
        } else if (isOk(data)) {
          this.safeToast({
            message: this.$lang.feature_unavailable || 'Withdrawal is temporarily unavailable. Please try again later.',
            icon: 'cross'
          })
        } else {
          this.showRequestError(data)
        }
      } catch (e) {
        this.showRequestError(e)
      } finally {
        this.submitting = false
      }
    },
    getSelect(i, v) {
      this.bankCard = v.value
      this.bankName = v.label
      this.selectIndex = i
    },
    async WithdrawInit() {
      if (!this.ensureLogin()) return
      try {
        const data = await WithdrawInit()
        if (isOk(data)) {
          this.withdrawReadError = ''
          const content = contentOf(data)
          const cards = Array.isArray(content.bankCardList)
            ? content.bankCardList
            : Array.isArray(content.cardList)
              ? content.cardList
              : []
          this.withdrawAmountMin = toNumber(content.withdrawAmountMin, 0)
          this.withdrawAmountSingleMax = toNumber(content.withdrawAmountSingleMax, 0)
          this.balLimit = toNumber(content._balLimit || content.balLimit, 0)
          this.balance = toNumber(content._balUsable || content.balance, 0)
          this.balWdl = toNumber(content._balWdl || content.balWdl, 0)
          this.isClose = normalizedCloseFlag(content.isClose)
          this.closeReason = content.closeReason || ''
          this.realName = content.realName || ''
          this.privacyPasswdSetted = normalizedPrivacyPasswdSetted(content.privacyPasswdSetted)
          this.bankCardList = normalizeRechargeBankCardList(cards)
          this.columns = this.bankCardList.map((item) => ({
            value: item.bankCard || '',
            label: item.bankName || '',
            cardId: item.cardId
          }))
          if (this.columns.length > 0) {
            this.getSelect(0, this.columns[0])
          } else {
            this.bankCard = ''
            this.bankName = ''
            this.selectIndex = 0
          }
          if (!this.realName) {
            this.safeToast({
              message: this.$lang.AuthName_txt || 'Please verify your real name first',
              icon: 'cross'
            })
            this.$jumpTo('/authName', { from: 'recharge' })
          } else if (this.privacyPasswdSetted === 'no') {
            this.goSetPassword()
          }
        } else {
          this.showWithdrawInitError(data)
        }
      } catch (e) {
        this.showWithdrawInitError(e)
      }
    },
    gotoBank() {
      this.$emit('goToActive', 1)
    },
    toggleRotation() {
      if (this.isRotating) return
      this.isRotating = true
      setTimeout(() => {
        this.isRotating = false
      }, 1000)
      this.WithdrawInit()
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  padding-bottom: 20px;
  .p-line {
    height: 1px;
    background: @border-color;
  }
  .withdraw-read-error {
    margin: 10px;
    padding: 8px 10px;
    border-radius: 5px;
    background: rgba(255, 76, 76, 0.12);
    color: @error-color;
    font-size: var(--vk-fs-xs);
    line-height: 18px;
  }
  .type-item {
    position: relative;
    border-radius: 5px;
    border: 1px solid @info-color;
    height: 38px;
    background: @cont-bg;
  }
  .badgeIcon-c {
    position: absolute;
    top: 20px;
    right: 0;
  }
  .badgeIcon {
    position: relative;
    border-left: 16px solid transparent;
    // border-right: 0px solid transparent;
    border-bottom: 16px solid @info-color;
    // border-radius: 0 0 3px 0;
  }
  .badgeIcon-i {
    position: absolute;
    right: 0;
    top: 6px;
    width: 10px;
  }
  .bank-list {
    padding: 18px 10px;
  }
  .bank-list-add {
    padding: 12px 10px 12px 5px;
    border: 1px solid @border-color;
    border-radius: 5px;
    // background: #f5f5f5;
  }
}
.bank-mid {
  padding: 10px;
  // background: #f5f5f5;
}

.bank-add {
  // background: #f5f5f5;
  padding: 18px 10px;
}

/* 定义旋转动画 */
@keyframes rotate-and-back {
  0%,
  100% {
    transform: rotate(0deg); /* 初始和最终状态 */
  }
  50% {
    transform: rotate(360deg); /* 顺时针旋转360度 */
  }
}
/* 动画类 */
.rotating {
  animation: rotate-and-back 1s linear forwards; /* 4秒完成动画，线性过渡，动画结束后保留状态 */
}
.arrow-up {
  transform: rotate(-180deg); /* 箭头向上时旋转180度 */
}
.select-active {
  // background-image: linear-gradient(99deg, #ffaf00 0%, #7041f3 85%);
  background: #3979e3;
  font-weight: bold;
  color: #ffffff;
}
.bank-select {
  position: absolute;
  border: 1px solid @border-color;
  border-radius: 10px;
  width: 100%;
  background: @cont-bg;
  z-index: 9;
  height: 150px;
  overflow-y: auto;
  padding: 10px 0;
}
.bank-select--i {
  padding: 10px 0;
}
</style>
